export default {"src":"/_next/static/image/public/images/flags/flag_381.007646032581153b272386d372dce3a9.svg","height":16,"width":24};